// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

const styles = theme => ({
  section: {
    maxWidth: '1920px',
    width: '100%',
    padding: '0 80px',
    [theme.breakpoints.down(1800)]: {
      padding: '0 60px',
    },
    [theme.breakpoints.down(1550)]: {
      padding: '0 50px',
    },
    [theme.breakpoints.down(1367)]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down(1025)]: {
      padding: '0 30px',
    },
    [theme.breakpoints.down(769)]: {
      padding: '0 20px',
    },
    [theme.breakpoints.down(500)]: {
      padding: '0 4px',
    },
  },
  paddingRightZero: {
    paddingRight: 0,
  },
  paddingZero: {
    padding: 0,
  }
});

export default styles;
